// Init video source, transform video stream
const transformVideoStream = true
window.initVideoSrc(transformVideoStream)

// Init menu and activate item
const menuIndex = 2
window.initMenu(menuIndex)

// Process video stream
const Processor = require('./processor.js')

class CustomProcessor extends Processor {
  transformImage () {
    const imageData = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height)
    const data = imageData.data

    for (let i = 0; i < data.length; i += 4) {
      const rgb = this.blinder.protanopia('rgb(' + data[i] + ', ' + data[i + 1] + ', ' + data[i + 2] + ')', true)
      data[i] = rgb.R // red
      data[i + 1] = rgb.G // green
      data[i + 2] = rgb.B // blue
    }

    this.context.putImageData(
      imageData,
      0,
      0,
      0,
      0,
      this.video.width,
      this.video.height
    )
  }
}

// eslint-disable-next-line no-new
new CustomProcessor()
